var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1697_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9418 20.625H4.68749C2.10276 20.625 0 18.5222 0 15.9375V4.68749C0 2.10281 2.10276 0 4.68749 0H19.3125C21.8972 0 24 2.10281 24 4.68749V12.8213C24 13.3391 23.5802 13.7588 23.0625 13.7588C22.5447 13.7588 22.125 13.3391 22.125 12.8213V4.68749C22.125 3.13668 20.8633 1.875 19.3125 1.875H4.68749C3.13668 1.875 1.875 3.13668 1.875 4.68749V15.9375C1.875 17.4883 3.13668 18.75 4.68749 18.75H13.9418C14.4595 18.75 14.8793 19.1697 14.8793 19.6875C14.8793 20.2052 14.4595 20.625 13.9418 20.625Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125C10.4492 13.125 9.1875 11.8633 9.1875 10.3125C9.1875 8.76167 10.4492 7.49998 12 7.49998C13.5508 7.49998 14.8125 8.76167 14.8125 10.3125C14.8125 11.8633 13.5508 13.125 12 13.125ZM12 9.37498C11.4831 9.37498 11.0625 9.79555 11.0625 10.3125C11.0625 10.8294 11.4831 11.25 12 11.25C12.5169 11.25 12.9375 10.8294 12.9375 10.3125C12.9375 9.79555 12.5169 9.37498 12 9.37498Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.62499C12.5178 5.62499 12.9375 5.20526 12.9375 4.68749C12.9375 4.16973 12.5178 3.74999 12 3.74999C11.4822 3.74999 11.0625 4.16973 11.0625 4.68749C11.0625 5.20526 11.4822 5.62499 12 5.62499Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6936 6.69927C9.21137 6.69927 9.6311 6.27954 9.6311 5.76177C9.6311 5.24401 9.21137 4.82427 8.6936 4.82427C8.17584 4.82427 7.7561 5.24401 7.7561 5.76177C7.7561 6.27954 8.17584 6.69927 8.6936 6.69927Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3062 6.69927C15.8239 6.69927 16.2437 6.27954 16.2437 5.76177C16.2437 5.24401 15.8239 4.82427 15.3062 4.82427C14.7884 4.82427 14.3687 5.24401 14.3687 5.76177C14.3687 6.27954 14.7884 6.69927 15.3062 6.69927Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875 16.875H6.375C5.85722 16.875 5.4375 16.4553 5.4375 15.9375C5.4375 15.4197 5.85722 15 6.375 15H13.875C14.3928 15 14.8125 15.4197 14.8125 15.9375C14.8125 16.4553 14.3928 16.875 13.875 16.875Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7874 21.1331C23.5323 20.4474 24.0001 19.4649 24.0001 18.375C24.0001 16.3072 22.3178 14.625 20.2501 14.625C18.1823 14.625 16.5001 16.3072 16.5001 18.375C16.5001 19.4649 16.9678 20.4474 17.7127 21.1331L16.6876 22.5C16.3769 22.9142 16.4608 23.5018 16.8751 23.8125C17.2892 24.1231 17.877 24.0392 18.1876 23.625L19.3884 22.0239C19.6652 22.0893 19.9535 22.125 20.2501 22.125C20.5466 22.125 20.8349 22.0893 21.1118 22.0239L22.3126 23.625C22.6232 24.0391 23.2109 24.1231 23.6251 23.8125C24.0393 23.5018 24.1232 22.9142 23.8126 22.5L22.7874 21.1331ZM18.3751 18.375C18.3751 17.3411 19.2162 16.5 20.2501 16.5C21.2839 16.5 22.1251 17.3411 22.1251 18.375C22.1251 19.4088 21.2839 20.25 20.2501 20.25C19.2162 20.25 18.3751 19.4088 18.3751 18.375Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1697_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.29bd58ebc4613bbe95be62eedc8650f4.svg";
export { ForwardRef as ReactComponent };